/* Library */
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import Link from '../../../../../components/ZUILib/Link';
import pdfUtil from '../../../../../utils/PDFUtil';
import { constDownload, constSendMail } from '../../../../../utils/clientConstant';
import StatementPrintAndDownload from '../StatementPrintAndDownload';
import commonUtil from '../../../../../utils/commonUtil';
import AppEvents from '../../../../App/AppEvents';
import DownloadPDFWithoutPreview from '../../../../../components/DownloadPDFWithoutPreview';
import { sendMail } from '../../actions';

const channel = commonUtil.getChannel();
const constChannels = commonUtil.getClientConstForChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

const pageName = 'accountstatus';
class AccountPartialTransferWAP extends Component {
  constructor(props) {
    super(props);
    this.eventId = this.props.eventId;
    this.state = {
      transferenceSummary: null,
      transferenceDetails: null,
      emailSendStatus: null,
    };
  }
  componentDidMount() {
    if (channel === constChannels.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
      if (this.wapBackButtonEvent) {
        AppEvents.publish(this.wapBackButtonEvent, [() => {
          browserHistory.push(commonUtil.routeTo(applicationRoutes.accountStatus, { eventID: this.eventId }));
        }]);
      }
    }
    this.props.getAccountPartialTransferDetails();
  }
  componentWillUnmount() {
    AppEvents.unsubscribe(this.wapBackButtonEvent);
  }

  updateData(partialTransferData) {
    this.setState({
      transferenceSummary: partialTransferData.transferenceInfo.transferenceSummary,
      transferenceDetails: partialTransferData.transferenceInfo.transferenceDetails,
    });
  }

  getStatementDetailsForDownload = () => {
    this.printDownloadMail(constDownload);
  }
  getStatementDetailsForSendMail = () => {
    this.printDownloadMail(constSendMail);
  }
  accountStatementSendMail = (fileName, data) => {
    const emailId = !commonUtil.isObjectEmpty(this.props.user) && this.props.user.result && this.props.user.result.emailId;
    sendMail(this.eventId, fileName, data, emailId).then((res) => {
      pdfUtil.contentDownloadedCallback();
      if (res.body.status === 'success') {
        this.setState({ emailSendStatus: { isSent: true, resMsg: commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailsent.message') } });
      } else {
        this.setState({ emailSendStatus: { isSent: false, resMsg: commonUtil.getLabel(this.props.lables.eventAccountStatement, 'accountStatement.emailfailed.message') } });
      }
    });
  }


  getStatementDetailsForPrintAndDownloadError(data) {
    this.setState({ emailSendStatus: { isSent: false, resMsg: data.error } });
  }
  printDownloadMail = (type) => {
    if (type === constSendMail) {
      const mailContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDomForMail(mailContent, 'accountStatement', this.accountStatementSendMail);
    } else if (type === constDownload) {
      const downloadableContent = (<DownloadPDFWithoutPreview pageName={pageName} printingDate={this.props.printingDate} download><StatementPrintAndDownload statementPrintAndDownload={this.props.statementDetailsForPrintAndDownloadData} eventDetailsInfo={this.props.eventInfo} type={this.downloadPrintType} accountStatus={this.props.accountStatus} /></DownloadPDFWithoutPreview>);
      pdfUtil.attachToDom(downloadableContent, ('accountstatus_' + this.eventId));
    }
  }
  render() {
    const { transferenceSummary, transferenceDetails } = this.state;

    const DownloadIcon = {
      route: '',
    };
    const emailSendLink = {
      cssClass: 'icon-tache2 closeAlert',
      onClickHandler: () => { this.setState({ emailSendStatus: null }); },
    };

    const partialWebRow = (data, index) => {
      const number = data.number.replace(/.(?=.{4})/g, 'x');
      return (
        <div key={index}>
          <div className="row mt-5 gadgetInfoArticle">
            <div className="col-xs-12 inner shadowSquare">
              <div className="row content">
                <div className="col-xs-12 columnInfo">
                  <p className="rowText">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel1')} de retiro:<span>{commonUtil.formatDate(data.date, 'dd/mm/yyyy')}</span></p>
                  <p className="rowText">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel2')}:<span>{data.storeName}</span></p>
                  <p className="rowText">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel3')}:<span>{data.userName}</span></p>
                  <p className="rowText">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel6')}:<span>{data.transferenceMethod}</span></p>
                  <p className="numCard">{number}</p>
                  <p className="rowText">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel4')}:<span>-{commonUtil.getCurrency(data.commission)}</span></p>
                  <p className="rowText">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.columnLabel5')}:<span>-{commonUtil.getCurrency(data.amountTransferred)}</span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    };
    return (
      <div>
        <div className="accountState">
          <div className="row">
            <div className="col-xs-12 pt-15">
              <p className="name">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label1')}</p>
            </div>
          </div>

          {!_.isEmpty(transferenceSummary) ? <React.Fragment>
            <div className="row bt-1 bb-1 bc-gray">
              <div className="col-xs-12 innerItem">
                <div className="td-80">
                  <p className="disponibility">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label3')}</p>
                </div>
                <div className="td-16 text-right">
                  <p className="mont">{transferenceSummary.totalTransactionToMonedero}</p>
                </div>
              </div>
            </div>
            <div className="row bb-1 bc-gray">
              <div className="col-xs-12 innerItem">
                <div className="td-60">
                  <p className="disponibility">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label4')}</p>
                </div>
                <div className="td-36 text-right">
                  <p className="mont">{transferenceSummary.totalTransactionsToBank}</p>
                </div>
              </div>
            </div>
            <div className="row bb-1 bc-gray">
              <div className="col-xs-12 innerItem">
                <div className="td-60">
                  <p className="disponibility">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label5')}</p>
                </div>
                <div className="td-36 text-right">
                  <p className="mont return">-{commonUtil.getCurrency(transferenceSummary.totalTransferredAmount)}</p>
                </div>
              </div>
            </div> </React.Fragment> : null}


          {this.state.emailSendStatus ?
            <React.Fragment>
              {this.state.emailSendStatus.isSent ?
                <div className="alertSuccess" > <i className="icon-check" />
                  <p>{this.state.emailSendStatus.resMsg}</p>
                  <Link linkJSON={emailSendLink} />
                </div> :
                <div className="alertError" > <i className="icon-tache2" />
                  <p>{this.state.emailSendStatus.resMsg}</p>
                  <Link linkJSON={emailSendLink} />
                </div>}
            </React.Fragment> : null}
          <div className="row">
            <div className="col-xs-12 pt-15 pb-15">
              <div className="toolsLink text-right" id="transferencesOptions">
                <Link rrLink={DownloadIcon} >
                  <i className="icon-descarga" onClick={this.getStatementDetailsForDownload} aria-hidden="true" />
                </Link>
                <Link rrLink={DownloadIcon} >
                  <i className="icon-correo" onClick={this.getStatementDetailsForSendMail} aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12 bb-1 bc-gray">
              <p className="titleTable">{commonUtil.getLabel(this.props.lables['Partial transference Page'], 'accountStatement.partialTransfer.label2')}</p>
            </div>
          </div>
          {transferenceDetails ? transferenceDetails.map(partialWebRow) : null}
        </div>
      </div>
    );
  }
}

export default AccountPartialTransferWAP;
